import React, { useContext } from 'react';
import { ProdutosPlanilhaContext } from '../../../../contexts/ProdutosPlanilha/ProdutosPlanilhaContext';
import Swal from 'sweetalert2';
import { Toggle } from '../../../Toggle/Toggle';
import { useTheme } from '../../../../contexts/Theme/ThemeContext';
import { ConfiguracoesAvancadasContainer, Botoes } from './styles';
import Titulo from '../../../Modal/ModaisConfigsPrimeiroAcesso/Titulo/Titulo';
import { ReactComponent as Voltar } from "../../../../assets/newImages/icons/angle-down.svg";
import Modal from '../../../Modal/Modal';
import { Button } from '../../../Button';

interface ConfiguracoesAvancadasProps {
  isOpen: boolean;
  onClose: () => void;
}

const ConfiguracoesAvancadas: React.FC<ConfiguracoesAvancadasProps> = ({ isOpen, onClose }) => {
  const { removerProdutos, setRemoverProdutos } = useContext(ProdutosPlanilhaContext);
  const {theme} = useTheme();

  const handleToggleChange = (newValue: boolean) => {
    if (newValue) {
      Swal.fire({
        title: "Excluir todos produtos?",
        text: "Ao habilitar essa opção, todos os produtos da conta cadastrados anteriormente serão excluídos.",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Excluir Produtos",
        customClass: {
          confirmButton: 'btn-confirm',
          icon: 'custom-swal-icon',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          setRemoverProdutos(newValue);
        } else {
          setRemoverProdutos(false);
        }
      });
    } else {
      setRemoverProdutos(newValue);
    }
  };

  return (
    <Modal
      width={"60rem"}
      maxWidth="98vw"
      isOpen={isOpen}
      backdrop={"static"}
      setModal={onClose}
    >
      <ConfiguracoesAvancadasContainer theme={theme}>
        <Titulo
          titulo="Excluir produtos"
          subtitulo="Atenção, essa ação é irreversivel."
          flexDirection="column-reverse"
        />
        <div className="remover-produtos">
          <label className="fonteTexto">
            <Toggle
              value={removerProdutos}
              onChange={handleToggleChange}
            />
            Excluir produtos existentes
          </label>
          <p className="texto fonteRotulos">
            <strong>
              Se habilitada essa opção, serão excluídos todos os<br /> produtos da conta cadastrados anteriormente.
            </strong>
            <br />
            Após a exclusão, os produtos que estão no arquivo de<br /> importação serão cadastrados.
          </p>
        </div>
        <Botoes theme={theme}>
          <div
            className='cancelar'
            title='Voltar'
            onClick={onClose}
          >
            <Voltar /> Voltar
          </div>
        </Botoes>
      </ConfiguracoesAvancadasContainer>
    </Modal>
  );
};

export default ConfiguracoesAvancadas;
